import React, { Component } from 'react';

class Amount extends Component {
  render() {
    const { amount } = this.props;
    let result = '';

    if (typeof amount === 'number') {
      result = amount.toLocaleString('nl', {
        style: 'currency',
        currency: 'EUR'
      });
    }

    return (
      <span>
        {result}
      </span>
    );
  }
}

export default Amount;



// WEBPACK FOOTER //
// ./src/shared/Amount.js